module.exports = __webpack_public_path__ + "static/scale-model-of-house-of-dance-&-feathers-in-new-orleans-louisiana-2253534023e1eed173ae9884f1b2a3c9.png";